export default __webpack_public_path__ + "assets/spacesettlement.d3c29013.png";